import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import vuetify from './plugins/vuetify'
import lodash from 'lodash'
// import VueLodash from 'vue-lodash'
import Croppa from 'vue-croppa'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
import 'vue-croppa/dist/vue-croppa.min'
import 'vue-wysiwyg/dist/vueWysiwyg.css'
import wysiwyg from 'vue-wysiwyg'

Vue.use(lodash, lodash)
Vue.use(Croppa)
Vue.use(wysiwyg, {})

Vue.use(TiptapVuetifyPlugin, {
  vuetify,
  iconsGroup: 'mdi',
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created() {
    // Prevent blank screen in Electron builds
    // this.$router.push('/')
  },
}).$mount('#app')
